import { View } from "binder"
import { StopGroupEditorViewModel } from "./stopGroupEditor-viewModel"

export class StopGroupEditorView extends View<StopGroupEditorViewModel> {
    GetViewUniqueId(): string {
        return "V-C5D50AEE-8BAA-4CA0-8364-10DE778486CB"
    }
    loadHtml(): string {
        let element = require('./stopGroupEditor.html').default;
        let style = require('./stopGroupEditor.less');
        return element;
    }
    constructor() {
        super();
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    back() {
        this.dataContext.back();
    }

    save() {
        this.dataContext.save();
    }
}
